import { fetchJSON } from "./utils";

// Example usage:
// const result = await api.comments.fetchAllInteractionComments("4f9c3756-57c6-4ba2-847b-d9b1fecf9239")
export async function fetchAllInteractionComments(interaction_id) {
  const url = `/api/comments/interaction/${interaction_id}`;
  const resp = await fetchJSON(url, null, null, "get", false);
  return resp.data;
}

// Example usage:
// const data = {
//     interaction_id: "4f9c3756-57c6-4ba2-847b-d9b1fecf9239", // interaction in question
//     organization_id: "5dac9dfd44a0499abccc3d26ab9067d0", // organization of interaction (interaction.company_id)
//     comment_text: "This is a test comment 3 with full name" // the comment text
//   };
// const result = await api.comments.createComment(data)
export function createComment(data) {
  const url = "/api/comments/";
  return fetchJSON(url, null, data, "post");
}

export function deleteComment(id) {
  const url = `/api/comments/${id}`;
  return fetchJSON(url, null, null, "delete");
}
